import React from 'react'

import {WineInfoPE} from '../../components/modules/accordion/WineInfo';
import {WineTerroirPE} from '../../components/modules/accordion/WineTerroir';
import {WineCellerPE} from '../../components/modules/accordion/WineCeller';
import {WineEttColtPE} from '../../components/modules/accordion/WineEttColt';
import {WineBottlesPE} from '../../components/modules/accordion/WineBottles';

function Pescara({data}) {
    return (
    <>
      {data[0] && <WineInfoPE />}
      {data[1] && <WineTerroirPE />}
      {data[2] && <WineCellerPE />}
      {data[3] && <WineEttColtPE />}
      {data[4] && <WineBottlesPE />}
      </>
    )
}

export default Pescara;
